import { EditableTag } from "@/components/2/editable-tag";
import { Tag } from "@/components/2/tag";

import {
  GeographicalAgencyTypeOptions,
  GeographicalAgencyTypeOptionsType,
} from "./geographical-agency-type-options";

type GeographicalAgencyTypeTagProps = {
  geographicalAgencyTypeValue: GeographicalAgencyTypeOptionsType | null;
  onChange?: (core_agency: boolean, close_core_agency: boolean) => void;
};
export const GeographicalAgencyTypeTag = ({
  geographicalAgencyTypeValue,
  onChange,
}: GeographicalAgencyTypeTagProps) => {
  // If read-only, just display the tag
  if (!onChange) {
    const currentType =
      geographicalAgencyTypeValue && GeographicalAgencyTypeOptions[geographicalAgencyTypeValue];
    return currentType ? <Tag label={currentType.label} colorPalette={currentType.color} /> : null;
  }

  return (
    <EditableTag
      name="agencies"
      value={geographicalAgencyTypeValue}
      description="Sélectionnez la zone d’intervention pour l’agence : "
      onChangeValue={value => onChange(value === "coreAgency", value === "closeCoreAgency")}
      options={Object.entries(GeographicalAgencyTypeOptions).map(([key, type]) => ({
        value: key,
        label: type.label,
        color: type.color,
      }))}
    />
  );
};
